export type Course = {
  id: string; title: string; description: string; playlist_id: string; language: string;
  source_type: 'playlist' | 'video'; video_id: string | null; thumbnail_video_id: string | null;
  status: 'draft' | 'published' | 'archived'; sort_order: number; updated_at: string;
};
export type CourseForm = Omit<Course, 'id' | 'updated_at'> & { id?: string };
async function request<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, { ...init, headers: { 'Content-Type': 'application/json' } });
  const data = await response.json() as T & { error?: string };
  if (!response.ok) throw new Error(data.error || 'Request failed.');
  return data;
}
export const listCourses = () => request<Course[]>('/api/courses');
export const listManagedCourses = () => request<Course[]>('/api/courses?scope=admin');
export const saveCourse = (data: CourseForm) => request<{ id: string }>('/api/courses', { method: 'POST', body: JSON.stringify(data) });
export const removeCourse = (id: string) => request<{ ok: boolean }>(`/api/courses?id=${encodeURIComponent(id)}`, { method: 'DELETE' });
